const checkLogin = async function (loginResult) {
    const promiseResult = await fetch('/loginAction', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ action: 'checkLogin' }),
    });
    const data = await promiseResult.json();
    if (typeof loginResult === 'object') {
        loginResult.isLoggedIn = data.isLoggedIn;
        loginResult.message = data.message;
    }
    return data.isLoggedIn;
};

export default checkLogin;
